import { CrudPage } from '@restavo/crud';
import React from 'react';
import { restaurantTablesPage } from 'src/features/restaurantTables';

const RestaurantTablesSettings = React.memo(() => <CrudPage {...restaurantTablesPage} />);

export default RestaurantTablesSettings;
